// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__jiTRX","requiredAsterisk":"Info_requiredAsterisk__3VKQT"};